import merge from 'lodash/merge';
import every from 'lodash/every';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import { getChartColors } from 'app/actions/theme.actions';
import * as api from 'dashboard/resources/my-price-point-mix.api';
import template from './my-price-point-mix-widget.html';
import chartConfig from './my-price-point-mix-chart.conf.json';

const mapStateToThis = ({ config, session, dictionary, theme }) => {
  const { locale, retailer } = session;
  const { pricePointMixWeeks } = config;
  const terms = dictionary.terms[locale];

  return {
    retailer,
    terms,
    theme,
    pricePointMixWeeks,
  };
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state', 'gettextCatalog', '$filter')
class MyPricePointMixWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.colors = getChartColors(this.theme.colors);
    this.chartConfig = this.extendChartConfig(chartConfig.donut);
    this.totalAmt = 0;
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.loadDataAsync(() => api.fetchMyPricePointMix(retailerId), this.transformData.bind(this));
  }

  $onDestroy() {
    this.unsubscribe();
  }

  transformData(data) {
    this.checkIfAllEmptyData(data);
    let formattedData = data.map((item) => ({
      key: item.pricePoint,
      y: item.salesAmt,
    }));
    formattedData = this.setColors(formattedData);
    this.setPricePoints(formattedData);
    if (this.chartApi) {
      this.chartApi.updateWithData(formattedData);
    }

    return formattedData;
  }

  setColors(data) {
    return data.map((item, index) => ({
      ...item,
      color: this.colors[index],
    }));
  }

  setPricePoints(data) {
    this.pricePoints = [];
    this.missingPricePoints = [];
    data.forEach((item) => {
      this.totalAmt += item.y;
      if (item.y) {
        this.pricePoints.push(item.key);
      } else {
        this.missingPricePoints.push(this.$filter('currency')(item.key, undefined, 0));
      }
    });
    this.missingPricePoints = this.missingPricePoints.join(', ');
  }

  extendChartConfig(chartConf) {
    return merge(chartConf, {
      chart: {
        x: (d) => this.$filter('currency')(d.key, undefined, 0),
        tooltip: {
          valueFormatter: (tickVal) => {
            const percent = Math.round((tickVal / this.totalAmt) * 100, 0);
            return `<strong>${percent}%</strong> ${this.gettextCatalog.getString('of sales')},<br><strong>${this.$filter('currency')(
              tickVal,
              undefined,
              0
            )}</strong> ${this.gettextCatalog.getString('in sales')}`;
          },
        },
        dispatch: {
          renderEnd: () => this.centerText(),
        },
      },
    });
  }

  centerText() {
    const svg = d3.select('.my-price-point-mix-widget--chart-area svg');
    const donut = svg.select('g.nv-pie .nv-pie');

    // Insert first line of text into middle of donut pie chart
    donut
      .insert('text', 'g')
      .text(this.gettextCatalog.getString('Last ') + this.pricePointMixWeeks)
      .attr('class', 'middle')
      .attr('text-anchor', 'middle')
      .attr('dy', '-.55em')
      .style('fill', '#606060');
    // Insert second line of text into middle of donut pie chart
    donut
      .insert('text', 'g')
      .text(this.gettextCatalog.getString("Weeks' Sales"))
      .attr('class', 'middle')
      .attr('text-anchor', 'middle')
      .attr('dy', '.85em')
      .style('fill', '#606060');
  }

  checkIfAllEmptyData(data) {
    this.isEmptyData = every(data, { salesAmt: 0 });
  }
}

export default class MyPricePointWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = MyPricePointMixWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/my-price-point-mix/my-price-point-mix-widget-component.js